import styled from 'styled-components';

export const SWrapper = styled.div`
  padding: 40px 20px;
`;
